import { render } from "./PunishmentTransactionForm.vue?vue&type=template&id=1aa5774b&scoped=true"
import script from "./PunishmentTransactionForm.vue?vue&type=script&lang=js"
export * from "./PunishmentTransactionForm.vue?vue&type=script&lang=js"

import "./PunishmentTransactionForm.vue?vue&type=style&index=0&id=1aa5774b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa5774b"]])

export default __exports__